import React, {Fragment, useEffect, useState} from "react";
import {v4} from "uuid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import AirIcon from '@mui/icons-material/Air';
import DeleteIcon from '@mui/icons-material/Delete';
import {Checkbox, DialogTitle, FormControlLabel, ListSubheader} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CheckIcon from '@mui/icons-material/Check';
import {rollStep} from "../../_helper/rollStep";
import {displayMod} from "../../_helper/displayMod";
import {rollerSetRolled} from "../../_helper/rollBehave";
import {
    s_char,
    s_char_grimoirespells,
    s_char_matrices,
    s_char_matricespells
} from "../../_signals/s_char";
import {s_char_attr_step} from "../../_signals/s_char_attr";
import {ICharTalent} from "../../_interfaces/ICharTalent";
import {ICharMatrice} from "../../_interfaces/ICharMatrice";
import {IRollerResult} from "../../_interfaces/IRoller";
import Button from "@mui/material/Button";
import {ResultsAdd} from "../../_api/BEResult";
import {s_chars_mods} from "../../_signals/s_chars_mods";
import {IResult} from "../../_interfaces/IResult";
import updChar from "../../_sig_api/updChar";
import {MatricespellsCreate, MatricespellsDelete} from "../../_api/BEMatricespells";
import {ICharMatriceSpell} from "../../_interfaces/ICharMatriceSpell";
import {matriceHasSpace} from "./matriceHasSpace";
import {ICharGrimoireSpell} from "../../_interfaces/ICharGrimoireSpell";
import {getWavingTalent} from "./getWeavingTalent";
import {matriceHasFreeSpace} from "./matriceHasFreeSpace";
import {s_app_cid, s_app_rid, s_app_sl} from "../../_signals/s_app";

interface IProp {
    open: string,
    isOpen: (open: string) => void
}

function MatriceSpellAttune({open, isOpen}: IProp) {

    const mod_rank = [...Array(16).keys()]

    const [attuneSpell, setAttuneSpell] = useState<ICharGrimoireSpell | null>(null)
    const [attuneMatrices, setAttuneMatrices] = useState<ICharMatrice[]>([])
    const [attuneOpen, setAttuneOpen] = useState(false)
    const [attuneRollOpen, setAttuneRollOpen] = useState(false)
    const [attuneResult, setAttuneResult] = useState<IRollerResult | null>(null)

    const [weaving, setWeaving] = useState<ICharTalent | null>(null)
    const [weavingKarma, setWeavingKarma] = useState(false)
    const [weavingStepMod, setWeavingStepMod] = useState(0)
    const [weavingMatrixId, setWeavingMatrixId] = useState('')

    useEffect(() => {
        if (open !== '') {
            let spell = s_char_grimoirespells.value.find(s => s.name == open);
            if (spell) {
                console.log('att matr', s_char_matrices.value)
                setAttuneMatrices(s_char_matrices.value);
                setAttuneOpen(true)
                setAttuneSpell(spell)
            }
        }
    }, [open])


    const attune = (matrixId: string) => {
        if (!attuneSpell) return

        let matrices = s_char_matrices.value;
        const f = matrices.findIndex((m) => m.id === matrixId);
        if (f >= 0) {
            const spell: ICharMatriceSpell = {
                id: v4(),
                cid: s_char.value.id,
                mid: matrices[f].id,
                name: attuneSpell.name,
                discipline: attuneSpell.discipline,
                weavediff: attuneSpell.weavediff,
                threads: attuneSpell.threads,
                castdiff: attuneSpell.castdiff,
                attunediff: attuneSpell.attunediff,
                circle: attuneSpell.circle,
                threadswoven: 0
            }
            MatricespellsCreate(spell)
            s_char_matricespells.value = [...s_char_matricespells.value, spell];
        }
    }

    const attuneMatrix = (matrixId: string) => {
        attune(matrixId)
    }

    const attuneMatrixFast = (matrixId: string) => {
        if (!attuneSpell) return
        let weaving = getWavingTalent(attuneSpell.discipline);
        if (weaving) {
            setWeavingStepMod(0);
            setWeavingKarma(false);
            setWeavingMatrixId(matrixId);
            setAttuneRollOpen(true)
            setWeaving(weaving)
            setAttuneResult(null)
        } else {
            alert('kein Fadenweben (' + attuneSpell.discipline + ') gefunden');
        }
    }


    const attuneRollRollAssign = () => {
        if (attuneResult && attuneSpell && attuneResult.result >= attuneSpell.weavediff) {
            attune(weavingMatrixId)
        }
        setAttuneRollOpen(false)
    }

    const attuneRollRoll = () => {
        if (!weaving || !attuneSpell) return
        let step = s_char_attr_step(weaving.attribute).value;
        step = step + weaving?.step;
        step = step + weavingStepMod;
        const mods = s_chars_mods.value.get(s_char.value.id)
        let mod = 0;
        mods?.forEach(m => {
            if (m.what === weaving.attribute) mod = mod + m.mmod
        })
        step = step + mod

        let rolled = rollStep(step, weavingKarma, attuneSpell.weavediff);
        setAttuneResult(rolled);

        rollerSetRolled(true);

        const result: IResult = {
            id: v4(),
            rid: s_app_rid.value,
            cid: s_app_cid.value,
            title: 'Abstimmen Fadenweben ' + attuneSpell?.name,
            name: s_char.value.name,
            nsc: s_char.value.nsc,
            sl: s_app_sl.value,
            eff: '',
            addEff: '',
            time: rolled.time,
            step: rolled.step,
            result: rolled.result,
            rolled: rolled.rolled,
            step_mod: rolled.step_mod,
            karma: rolled.karma,
            successes: rolled.successes,
            success: rolled.success,
            rollas: rolled.as,
            rollvs: rolled.vs
        };

        ResultsAdd(result);

        // überanstrengung durch schnell abstimmen
        const newSchaden = s_char.value.schaden + 1;
        s_char.value.schaden = newSchaden;
        updChar([{k: 'schaden', v: newSchaden}]);
    }

    const attuneMatrixRemove = (matriceSpellIdId: string) => {
        let matriceSpells = s_char_matricespells.value;
        const f = matriceSpells.findIndex((ms) => ms.id === matriceSpellIdId);
        if (f >= 0) {
            MatricespellsDelete(matriceSpells[f])
            matriceSpells = matriceSpells.filter(spell => spell.id !== matriceSpellIdId);
            s_char_matricespells.value = matriceSpells;
        }
    }

    return <Fragment>
        <Dialog open={attuneRollOpen}>
            <DialogTitle>Abstimmen Fadenweben</DialogTitle>
            <DialogContent>
                <div>{attuneSpell?.name}</div>
                <div>gegen Schwierigkeit: {attuneSpell?.weavediff}</div>
                <div>mit: {weaving?.name}</div>
                <div>Stufe: {weaving?.step} Attribut: {weaving?.attribute} Überanstrengung: {weaving?.strain}</div>
                <div>
                    {weaving?.karma ? <FormControlLabel
                        label="Karma"
                        control={
                            <Checkbox
                                checked={weavingKarma}
                                onChange={(e) => setWeavingKarma(e.target.checked)}
                            />
                        }
                    /> : null}
                    <Select key={v4()}
                            value={weavingStepMod}
                            onChange={(e) => setWeavingStepMod(e.target.value as number)}
                    >
                        <ListSubheader>Modifikator</ListSubheader>
                        {mod_rank.map(r => <MenuItem key={v4()} value={r}>{r}</MenuItem>)}
                    </Select>
                </div>
                <Button onClick={() => attuneRollRoll()}>würfeln</Button>
                {attuneSpell && attuneResult ? <div>
                        <div>Ergebnis: {attuneResult.result}</div>
                        <div>Gewürfelt: {attuneResult.rolled} {displayMod(attuneResult.step_mod)}
                            {attuneResult.karma ? ' Karma ' + attuneResult.karma : ''}
                        </div>
                        {attuneResult.result >= attuneSpell.weavediff ?
                            <Button onClick={() => attuneRollRollAssign()}>abstimmen</Button> : null}
                    </div>
                    : null}

            </DialogContent>
            <DialogActions>
                <Button onClick={() => isOpen('')}>abbruch</Button>
            </DialogActions>
        </Dialog>
        <Dialog open={attuneOpen}>
            <DialogTitle>Abstimmen {attuneSpell?.name}</DialogTitle>
            <DialogContent>
                {Array.isArray(attuneMatrices) && attuneMatrices.length === 0 ? 'keine passenden matrixen verfügbar' : null}
                {attuneMatrices.map(matrix =>
                    <div key={v4()}>
                        <hr/>
                        {matrix.name}

                        {s_char_matricespells.value.filter(ms => ms.mid === matrix.id).length > 0 ?
                            <Fragment key={v4()}>
                                <span style={{paddingLeft: 8}}>belegt mit</span>
                                {s_char_matricespells.value.filter(ms => ms.mid === matrix.id).map(
                                    (spell) => <div key={v4()}>
                                        {spell.name} {spell.circle}
                                        <IconButton aria-label="entfernen"
                                                    onClick={() => attuneMatrixRemove(spell.id)}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    </div>
                                )}
                            </Fragment> : null}
                        <Fragment key={v4()}>
                            {attuneSpell && matriceHasFreeSpace(matrix.id, attuneSpell.circle) ?
                                <div>
                                    Frei
                                    <IconButton aria-label="abstimmen"
                                                onClick={() => attuneMatrix(matrix.id)}>
                                        <CheckIcon/>
                                    </IconButton>
                                    <IconButton aria-label="schnellabstimmen"
                                                onClick={() => attuneMatrixFast(matrix.id)}>
                                        <AirIcon/>
                                    </IconButton>
                                </div>
                                : null
                            }
                        </Fragment>

                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => isOpen('')}>abbruch</Button>
            </DialogActions>
        </Dialog>
    </Fragment>
}

export default MatriceSpellAttune;
